/* Cambio del correo de acceso (pedido 27/10/2026, simplificado el mismo día).
   La administración lo cambia de una: no hay código de por medio, porque si la
   dueña no está disponible el cambio se quedaría trabado. Al correo viejo le
   llega un aviso de que ya no sirve y al nuevo que ese es su acceso. */
import { useState } from "react";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n/i18n";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Mail, AlertTriangle } from "lucide-react";
import { toast } from "sonner";

export const EmailChangeCard = ({ userId, currentEmail, onChanged }) => {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);
  const [nuevo, setNuevo] = useState("");
  const [confirmando, setConfirmando] = useState(false);
  const [busy, setBusy] = useState(false);

  const cerrar = () => { setOpen(false); setNuevo(""); setConfirmando(false); };

  const cambiar = async () => {
    setBusy(true);
    try {
      await api.post(`/users/${userId}/email-change`, { new_email: nuevo.trim() });
      toast.success(t("email_change_done", { email: nuevo.trim().toLowerCase() }));
      cerrar();
      onChanged?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || t("error_generic"));
      setConfirmando(false);
    } finally { setBusy(false); }
  };

  if (!open) {
    return (
      <Button size="sm" variant="outline" onClick={() => setOpen(true)}
              data-testid="email-change-open-button">
        <Mail className="h-3.5 w-3.5" /> {t("email_change_cta")}
      </Button>
    );
  }

  return (
    <div className="rounded-lg border border-slate-200 bg-slate-50 p-3" data-testid="email-change-form">
      <Label className="text-[11px]">{t("email_change_new")}</Label>
      <Input type="email" className="h-9 mt-1" placeholder={currentEmail}
             value={nuevo} disabled={confirmando}
             onChange={(e) => setNuevo(e.target.value)}
             data-testid="email-change-new-input" />
      <p className="text-[11px] text-slate-500 mt-2 leading-relaxed">{t("email_change_hint")}</p>

      {confirmando ? (
        <div className="mt-3 rounded-lg border border-amber-300 bg-amber-50 p-2.5"
             data-testid="email-change-confirm-box">
          <div className="flex items-start gap-2">
            <AlertTriangle className="h-4 w-4 text-amber-700 mt-0.5 shrink-0" />
            <p className="text-[11px] text-amber-900 leading-relaxed">
              {t("email_change_confirm_q")}{" "}
              <strong className="break-all">{nuevo.trim().toLowerCase()}</strong>
            </p>
          </div>
          <div className="mt-2 flex gap-2">
            <Button size="sm" onClick={cambiar} disabled={busy}
                    data-testid="email-change-confirm-button">
              {t("email_change_confirm_yes")}
            </Button>
            <Button size="sm" variant="ghost" onClick={() => setConfirmando(false)} disabled={busy}
                    data-testid="email-change-confirm-back">
              {t("cancel")}
            </Button>
          </div>
        </div>
      ) : (
        <div className="mt-2 flex gap-2">
          <Button size="sm" onClick={() => setConfirmando(true)} disabled={!nuevo.trim()}
                  data-testid="email-change-send-button">
            {t("email_change_apply")}
          </Button>
          <Button size="sm" variant="ghost" onClick={cerrar}
                  data-testid="email-change-close-button">
            {t("cancel")}
          </Button>
        </div>
      )}
    </div>
  );
};

export default EmailChangeCard;
